import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesGraphMobile from '../../pages/markets/component/futures-graph-mobile';

export const FuturesGraphWidget = () => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <FuturesGraphMobile flag="homepage" widget={true} />
    </QueryClientProvider>
  );
};
